import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Button = styled.button`
  display: inline-block;
  width: 80px;
  height: 40px;
  background-color: #eeeeee;
  margin-left: 10px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const TableContainer = styled.table`
  width: 100%;
  border: none;
  border-collapse: collapse;
  td,
  th {
    text-align: left;
    border: none;
    padding: 10px 12px;
    font-size: 14px;
  }
  tbody tr {
    height: 48px;
    transition: background 0.1s;
  }
  tbody tr:hover {
    background: rgba(0, 122, 255, 0.04);
  }
  thead > tr {
    background-color: #2d3748;
    height: 44px;
    border-bottom: none;
  }
  thead th {
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    letter-spacing: -0.01em;
  }
`;

const Table = ({ caption, titles, data, button, onRowClick }) => {
  const titlesIdx = Object.keys(data[0]);
  return (
    <Container>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h2>{caption}</h2>
        {button}
      </div>
      <TableContainer>
        <thead>
          <tr>
            {titles.map((title, index) => {
              return <th key={index}>{title}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              onClick={() => onRowClick && onRowClick(index)}
              style={onRowClick ? { cursor: 'pointer' } : {}}
            >
              {titlesIdx.map((title, index) => {
                if (title !== '_id') return <td key={index}>{item[title]}</td>;
                else return null;
              })}
            </tr>
          ))}
        </tbody>
      </TableContainer>
    </Container>
  );
};

export default Table;
